import { fetchUtils } from 'react-admin';
import { stringify } from 'query-string';
import config from './config.json';
import md5 from 'md5';
import { passwordSalt } from "./sharedData";
import { saveTokensDataProvider } from './utils/saveTokens'

const apiUrl = `${config.HOST_NAME}/crm/v3`;

const UPDATED_RESOURCES = {
    "rfidData": "v2/rfidData",
    "rfidLogs": "v2/rfidLogs"
};

const httpClient = (url, options = {}) => {
    if (!options.headers) {
        options.headers = new Headers({ Accept: 'application/json' });
    }
    options.headers.set('Authorization', `Bearer ${sessionStorage.getItem('token')}`);
    options.headers.set('RefreshToken', `Bearer ${sessionStorage.getItem('refresh_token')}`);
    return fetchUtils.fetchJson(url, options);
};

const dataProvider = {
    getList: (resource, params) => {
        if (UPDATED_RESOURCES[resource])
            resource = UPDATED_RESOURCES[resource];

        let { page, perPage } = params.pagination;
        if (resource === 'currentVehicles' || resource === 'pastVehicles') {
            page = params.filter.page + 1;
            perPage = params.filter.perPage;
        }
        const { field, order } = params.sort;
        const query = {
            sort: JSON.stringify([field, order]),
            page: JSON.stringify(page),
            perPage: JSON.stringify(perPage),
            filter: JSON.stringify(params.filter),
        };
        query.user_id = sessionStorage.getItem("user_id");
        // const valetPaths = ['valets/bookings']
        // if (valetPaths.includes(resource)) {
        //     query.access_key = params?.filter?.access_key
        //     query.parking_info_id = params?.filter?.parking_info_id
        // }

        const url = `${apiUrl}/${resource}?${stringify(query)}`;
        return httpClient(url).then(
            ({ headers, json }) => {
                saveTokensDataProvider(headers)
                if (!json.success) {
                    throw new Error(json.message);
                }
                // valetPaths.includes(resource) && json.data[0] ? json.data.map((val) => val.id ? val : {...val, id: val.license_number})
                return (
                    {
                        data: json.data,
                        total: parseInt(headers.get('content-range').split('/').pop(), 10),
                    }
                )

            }
        );
    },

    getMany: (resource, params) => {
        if (UPDATED_RESOURCES[resource])
            resource = UPDATED_RESOURCES[resource];

        console.log(`getMany : ${resource} : ${JSON.stringify(params)}`);
        const query = {
            filter: JSON.stringify({ id: params.ids }),
        };
        if (resource === 'parkingAccessKeys') {
            query.user_id = sessionStorage.getItem("user_id");
        }
        const url = `${apiUrl}/${resource}?${stringify(query)}`;
        return httpClient(url).then(
            ({ headers, json }) => {
                saveTokensDataProvider(headers)
                console.log(json);
                if (!json.success) {
                    throw new Error(json.message);
                }
                return (
                    {
                        data: json.data
                    }
                )
            })
    },

    getOne: (resource, params) => {
        if (UPDATED_RESOURCES[resource])
            resource = UPDATED_RESOURCES[resource];

        console.log(`getOne : ${resource}`, params);
        const query = {
            filter: JSON.stringify({ id: [params.id], includeSocieties: resource === "parkings" ? true : false }),
        };
        query.user_id = sessionStorage.getItem("user_id");
        const url = `${apiUrl}/${resource}?${stringify(query)}`;
        console.log(url);
        return httpClient(url).then(
            ({ headers, json }) => {
                saveTokensDataProvider(headers)
                console.log(json);
                if (!json.success) {
                    throw new Error(json.message);
                }
                return (
                    {
                        data: json.data[0]
                    }
                )
            })
    },

    update: async (resource, params) => {
        console.log(resource)
        if (UPDATED_RESOURCES[resource])
            resource = UPDATED_RESOURCES[resource];

        params.data.user_id = sessionStorage.getItem("user_id");
        if (resource === 'operatorUsers') {
            params.data.password = md5(params.data.password + passwordSalt)
            params.data.confirm_password = md5(params.data.confirm_password + passwordSalt)
        }
        if (resource === 'rfidOrganization') {
            params.data.password = md5("123456" + passwordSalt);
        }
        if (resource === 'crmUsers') {
            delete params.data.access_keys
            params.data.password = params.data && params.data.new_password ? md5(params.data.new_password + passwordSalt) : params.data.password
            params.data.confirm_password = md5(params.data.confirm_password + passwordSalt)
        }

        if (resource === 'operator/users') {
            if (params.data.edit_password && params.data.new_password && params.data.confirm_password) {
                params.data.new_password = md5(params.data.new_password + passwordSalt)
                params.data.confirm_password = md5(params.data.confirm_password + passwordSalt)
            }
        }
        let headers;
        let body = JSON.stringify(params.data);
        if (resource === "parkingInfo") {
            body = new FormData();
            for (let property in params.data) {
                if (property === "parking_images") {
                    const parkingImages = params.data[property] && params.data[property] !== "" ? JSON.parse(params.data[property]) : [];
                    const parkingImagesUri = [];
                    for (let i in parkingImages) {
                        if (parkingImages[i].search(/^blob:+/g) === -1)
                            parkingImagesUri.push(parkingImages[i]);
                        else {
                            const file = await fetch(parkingImages[i]).then(r => r.blob());
                            body.append("parkingImages", file, `${new Date().valueOf()}_${i}.jpg`);
                        }
                    }
                    body.append("parkingImages", JSON.stringify(parkingImagesUri));
                } else if (params.data[property] != null) {
                    body.append(property, typeof params.data[property] === "boolean" ? params.data[property] ? "1" : "0" : `${params.data[property]}`);
                }
            }
        }
        if (resource === "clientsInfo") {
            body = new FormData();
            for (let property in params.data) {
                if (property === "identity_proofs") {
                    console.log("hit")
                    const identityProofs = params.data[property] && params.data[property] !== "" ? JSON.parse(params.data[property]) : [];
                    const identityProofsUri = [];
                    for (let i in identityProofs) {
                        if (identityProofs[i].search(/^blob:+/g) === -1)
                            identityProofsUri.push(identityProofs[i]);
                        else {
                            const file = await fetch(identityProofs[i]).then(r => r.blob());
                            body.append("identityProofs", file, `${new Date().valueOf()}_${i}.jpg`);
                        }
                    }
                    body.append("identityProofs", JSON.stringify(identityProofsUri));
                } else if (params.data[property] != null) {
                    body.append(property, typeof params.data[property] === "boolean" ? params.data[property] ? "1" : "0" : `${params.data[property]}`);
                }
            }
        }

        return httpClient(`${apiUrl}/${resource}/${params.id}`, {
            method: 'PUT',
            headers,
            body,
        }).then(({ headers, json }) => {
            saveTokensDataProvider(headers)
            console.log(json);
            if (!json.success) {
                throw new Error(json.message);
            }
            return (
                {
                    data: json.data
                }
            )
        })
    },

    create: async (resource, params) => {
        if (UPDATED_RESOURCES[resource])
            resource = UPDATED_RESOURCES[resource];

        params.data.user_id = sessionStorage.getItem("user_id");
        if (resource === 'operatorUsers' || (resource === 'crmUsers')) {
            params.data.password = md5(params.data.password + passwordSalt)
            params.data.confirm_password = md5(params.data.confirm_password + passwordSalt)
        }
        if (resource === 'rfidOrganization') {
            params.data.password = md5("123456" + passwordSalt);
        }

        let headers;
        let body = JSON.stringify(params.data);
        if (resource === "clientsInfo") {
            body = new FormData();
            for (let property in params.data) {
                if (property === "identity_proofs") {
                    console.log("hit")
                    const identityProofs = params.data[property] && params.data[property] !== "" ? JSON.parse(params.data[property]) : [];
                    const identityProofsUri = [];
                    for (let i in identityProofs) {
                        if (identityProofs[i].search(/^blob:+/g) === -1)
                            identityProofsUri.push(identityProofs[i]);
                        else {
                            const file = await fetch(identityProofs[i]).then(r => r.blob());
                            body.append("identityProofs", file, `${new Date().valueOf()}_${i}.jpg`);
                        }
                    }
                    body.append("identityProofs", JSON.stringify(identityProofsUri));
                } else if (params.data[property] != null) {
                    body.append(property, typeof params.data[property] === "boolean" ? params.data[property] ? "1" : "0" : `${params.data[property]}`);
                }
            }
        }
        return httpClient(`${apiUrl}/${resource}`, {
            method: 'POST',
            headers,
            body
        }).then(({ headers, json }) => {
            saveTokensDataProvider(headers)
            if (!json.success) {
                if (resource === 'getParkingTerminals') {

                    if (json && json.data?.serial_mapped) {
                        let customError = new Error('')
                        customError.data = json.data
                        throw customError

                    } else throw new Error(json.message)

                } else throw new Error(json.message);
            }
            return (
                {
                    data: json.data
                }
            )
        })
    },

    delete: (resource, params) => {
        if (UPDATED_RESOURCES[resource])
            resource = UPDATED_RESOURCES[resource];

        params.user_id = sessionStorage.getItem("user_id");
        return httpClient(`${apiUrl}/${resource}/${params.id}`, {
            method: 'DELETE',
            body: JSON.stringify(params),
        }).then(({ headers, json }) => {
            saveTokensDataProvider(headers)
            if (!json.success) {
                throw new Error(json.message);
            }
            return ({ data: json.data });
        })
    },
    deleteMany: (resource, params) => {
        const query = {
            filter: { ids: params.ids },
        };
        return httpClient(`${apiUrl}/${resource}`, {
            method: 'DELETE',
            body: JSON.stringify(query.filter),
        }).then(({ json }) => ({ data: json }));
    },
    /*
        getManyReference: (resource, params) => {
            const { page, perPage } = params.pagination;
            const { field, order } = params.sort;
            const query = {
                sort: JSON.stringify([field, order]),
                range: JSON.stringify([(page - 1) * perPage, page * perPage - 1]),
                filter: JSON.stringify({
                    ...params.filter,
                    [params.target]: params.id,
                }),
            };
            const url = `${apiUrl}/${resource}?${stringify(query)}`;
    
            return httpClient(url).then(({ headers, json }) => ({
                data: json,
                total: parseInt(headers.get('content-range').split('/').pop(), 10),
            }));
        },
    
        update: (resource, params) =>
            httpClient(`${apiUrl}/${resource}/${params.id}`, {
                method: 'PUT',
                body: JSON.stringify(params.data),
            }).then(({ json }) => ({ data: json })),
    
        updateMany: (resource, params) => {
            const query = {
                filter: JSON.stringify({ id: params.ids }),
            };
            return httpClient(`${apiUrl}/${resource}?${stringify(query)}`, {
                method: 'PUT',
                body: JSON.stringify(params.data),
            }).then(({ json }) => ({ data: json }));
        },
    
        delete: (resource, params) =>
            httpClient(`${apiUrl}/${resource}/${params.id}`, {
                method: 'DELETE',
            }).then(({ json }) => ({ data: json })),
    
        deleteMany: (resource, params) => {
            const query = {
                filter: JSON.stringify({ id: params.ids }),
            };
            return httpClient(`${apiUrl}/${resource}?${stringify(query)}`, {
                method: 'DELETE',
                body: JSON.stringify(params.data),
            }).then(({ json }) => ({ data: json }));
        },
        */
};
export default dataProvider;